// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Your Tailwind CSS
import App from './App';
import { CompanyProvider } from './components/CompanySelector'; // Import CompanyProvider

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <CompanyProvider> {/* Wrap App with CompanyProvider */}
      <App />
    </CompanyProvider>
  </React.StrictMode>
);